import { buildQueryParams } from "../utils/buildQueryParams";
import { APIInstance } from "./api.config";

const { api } = new APIInstance({ path: "/v1/subscription/" });

export const SubscriptionService = {
  createPlan: (data) => {
    return api.post("plans", data);
  },
  updatePlan: (planId, data) => {
    return api.patch(`plans/${planId}`, data);
  },
  updatePlanValidity: (planId, data) => {
    return api.patch(`plans/${planId}/validity`, data);
  },
  getAllPlans: (filters = {}) => {
    const params = buildQueryParams(filters);
    return api.get(`plans?${params.toString()}`);
  },

  getPlanById: (planId) => {
    return api.get(`plans/${planId}`);
  },
  getAllModules: () => {
    return api.get("features");
  },
  getAllLimits: (companyId) => {
    return api.get(`limits/all${companyId ? `?companyId=${companyId}` : ""}`);
  },
  getLimitUsage: (moduleCode) => {
    return api.get(`limits/usage/${moduleCode}`);
  },
};
